// extracted by mini-css-extract-plugin
export var cartContainer = "_k6-4";
export var gray = "_k6-1";
export var itemContainer = "_k6-2";
export var itemDetails = "_k6-3";
export var strong = "_k6-0";